"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectColumn = exports.useSelectedIndexes = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
const CheckBox_1 = require("../../CheckBox");
const useSelectedIndexes = (data, rows, onChange) => {
    const lastDataRef = (0, react_1.useRef)();
    const selectedIndexesRef = (0, react_1.useRef)();
    if (lastDataRef.current !== data || !selectedIndexesRef.current) {
        selectedIndexesRef.current = new Array(data.length).fill(false);
        setTimeout(() => onChange === null || onChange === void 0 ? void 0 : onChange([]));
    }
    lastDataRef.current = data;
    const props = (0, react_1.useMemo)(() => {
        const indexes = selectedIndexesRef.current;
        const getSelectedRow = (index) => indexes[index];
        const selectRow = (index, value) => {
            indexes[index] = value;
            const items = rows.filter((_, i) => indexes[i]).map(row => row.original);
            onChange === null || onChange === void 0 ? void 0 : onChange(items);
        };
        const getSelectedRows = () => Boolean(indexes.length) && indexes.every(x => x);
        const selectRows = (value) => {
            for (let i = 0; i < indexes.length; i++) {
                indexes[i] = value;
            }
            const items = rows.filter((_, i) => indexes[i]).map(row => row.original);
            onChange === null || onChange === void 0 ? void 0 : onChange(items);
        };
        return {
            getSelectedRow,
            selectRow,
            getSelectedRows,
            selectRows,
        };
    }, [rows, onChange]);
    return props;
};
exports.useSelectedIndexes = useSelectedIndexes;
const selectColumn = (options) => ({
    Header: ({ getSelectedRows, selectRows, tableRef }) => {
        return (react_1.default.createElement(CheckBox_1.CheckBox, { checked: getSelectedRows(), onChange: (e) => {
                selectRows(e.target.checked);
                tableRef.current.renderColumn('selection');
            } }));
    },
    id: 'selection',
    isCheckboxColumn: true,
    disableSortBy: true,
    headerClasses: [`${__1.className}__selection`, 'table__cell--without-opacity'],
    cellClasses: ['table__cell--without-opacity'],
    Cell: ({ getSelectedRow, selectRow, rowIndex, tableRef }) => {
        return (react_1.default.createElement(CheckBox_1.CheckBox, { checked: getSelectedRow(rowIndex), onChange: (e) => {
                selectRow(rowIndex, e.target.checked);
                tableRef.current.renderColumn('selection');
            } }));
    },
    hidden: options === null || options === void 0 ? void 0 : options.hidden,
});
exports.selectColumn = selectColumn;
//# sourceMappingURL=selectColumn.js.map